<template>
  <div class="jxapgl">
    <Header title="教学安排管理" type="0" route="/homeIndex"></Header>
    <div class="jxapgl_header">
      <h3 class="jxapgl_header_title">教学安排</h3>
      <div class="jxapgl_header_info" @click="showPop('学年学期', 'xnxq')">
        <span class="jxapgl_header_xnxq">{{ xnxq.text }}</span>
        <van-icon class="jxapgl_header_icon" name="play" />
      </div>
    </div>
    <div class="jxapgl_main">
      <van-search
        v-model="ktmc"
        shape="round"
        background="#F5F5F5"
        placeholder="请输入班级名称"
        @input="getList"
      />
      <div class="jxapgl_content">
        <NOdata title="暂无教学安排管理数据~" v-if="list.length == 0"></NOdata>
        <mode-list
          v-else
          v-for="(item, index) in list"
          :key="index"
          :item="item"
          @detail="detail"
        ></mode-list>
      </div>
    </div>
    <van-popup v-model="show" round position="bottom">
      <van-picker
        :title="valueList.title"
        show-toolbar
        :columns="valueList.columns"
        @cancel="show = false"
        @confirm="
          (value, index) => {
            onConfirm(value, index, valueList.field);
          }
        "
      />
    </van-popup>
  </div>
</template>
<script>
import { Api } from "@/utils/axios";
import modeList from "./mode/modeList.vue";
export default {
  components: { modeList },
  data() {
    return {
      xnxq: {
        text: "",
        value: ""
      },
      ktmc: "",
      show: false,
      valueList: {
        title: "",
        field: "",
        columns: []
      },
      columns: {},
      list: []
    };
  },
  watch: {
    "xnxq.value": {
      handler(newVal, oldVal) { 
        if (newVal !== oldVal) {
          this.getList();
        }
      },
      deep: true
    }
  },
  created() {
    this.getXnxq();
  },
  methods: {
    detail(item) {
      this.$router.push({
        path: "/xkmdck/xkxslb",
        query: {
          item: item
        }
      });
    },
    async getList() {
      const res = await Api.findJxapglList({
        xnxq01id: this.xnxq.value,
        ktmc: this.ktmc
      });
      if (res.code == 1) {
        this.list = res.data;
      }
    },
    async getXnxq() {
      const res = await Api.findDictionry({ zzdtype: "xnxq" });
      if (res.code == 1) {
        let defaultIndexXnxq = 0;
        this.columns.xnxq = [
          {
            values: res.data.xnxq.map((item, index) => {
              if (item.isdqxq === "1") {
                defaultIndexXnxq = index;
                this.xnxq = {
                  text: item.xqmc,
                  value: item.xnxq01id
                };
              }
              return {
                text: item.xqmc,
                value: item.xnxq01id
              };
            }),
            defaultIndex: defaultIndexXnxq
          }
        ];
      }
    },
    // 弹出选择器
    showPop(title, field) {
      this.show = true;
      this.valueList.title = title;
      this.valueList.field = field;
      this.valueList.columns = JSON.parse(JSON.stringify(this.columns[field]));
    },
    // 选择确认
    onConfirm(value, index, field) {
      this.show = false;
      this[field] = value[0];
      //   this.getList();
    }
  }
};
</script>
<style lang="less" scoped>
.jxapgl {
  height: 100%;
  background-color: #f2f2f4;
  box-sizing: border-box;
  .jxapgl_header {
    width: 100%;
    height: 303px;
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    background-image: url("~@/assets/images/jxapgl_header_img.png");
    padding: 29px 20px;
    box-sizing: border-box;
    .jxapgl_header_title {
      font-family: SourceHanSansCN-Regular;
      font-size: 24px;
      color: #ffffff;
      letter-spacing: 2.18px;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.18);
      font-weight: 400;
      margin-bottom: 10px;
      line-height: 24px;
    }
    .jxapgl_header_info {
      display: flex;
      align-items: center;
      margin-bottom: 27px;
      color: #ffffff;
      .jxapgl_header_xnxq {
        font-family: PingFangSC-Semibold;
        font-size: 18px;
        letter-spacing: 0;
        text-align: right;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.18);
        font-weight: bolder;
        line-height: 25px;
      }
      .jxapgl_header_icon {
        font-size: 14px;
        transform: rotate(90deg);
        margin-left: 6px;
      }
    }
  }
  .jxapgl_main {
    height: calc(~"100% - 120px");
    margin-top: -183px;
    padding: 0 15px;
    /deep/.van-search {
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.06);
      border-radius: 8px;
      .van-search__content {
        background-color: #fff;
        border: 1px solid #7469f8;
      }
    }
    .jxapgl_content {
      height: calc(~"100% - 66px");
      margin-top: 10px;
      overflow: auto;
      border-radius: 8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/xkmdck/jxapgl.vue